import { AnimatedSection } from "./AnimatedSection"

interface ComingSoonItemProps {
  title: string;
  description: string;
}

function ComingSoonItem({ title, description }: ComingSoonItemProps) {
  return (
    <AnimatedSection className="bg-secondary p-6 rounded-xl">
      <h3 className="font-semibold mb-2 text-primary">{title}</h3>
      <p className="text-muted-foreground">{description}</p>
    </AnimatedSection>
  )
}

export function ComingSoon() {
  return (
    <section id="coming-soon" className="container mx-auto px-4 py-16 text-center">
      <h2 className="text-3xl font-bold mb-8"><span className="text-foreground">Coming </span><span className="text-primary">Soonish</span></h2>
      <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
        <ComingSoonItem 
          title="Smart Location Detection" 
          description="Share content with us and our AI will automatically identify and extract location details for quick saving."
        />
        <ComingSoonItem 
          title="Advanced Filters" 
          description="Organize and discover places with customizable categories and smart search filters."
        />
        <ComingSoonItem 
          title="Collaborative Lists" 
          description="Create and share location lists with friends to make group trip planning effortless."
        />
      </div>
    </section>
  )
} 